<template>
  <PrimeIconField class="tw-w-full md:tw-max-w-[32rem]">
    <PrimeInputIcon>
      <MagnifyingGlassIcon />
    </PrimeInputIcon>
    <PrimeInputText
      :value="modelValue"
      :placeholder="placeholder"
      class="tw-w-full"
      @input="handleInput($event)"
    />
  </PrimeIconField>
</template>

<script setup lang="ts">
import MagnifyingGlassIcon from '~icons/fluent/search-20-filled'

defineProps<{
  modelValue: string
  placeholder?: string
}>()

const emit = defineEmits(['update:modelValue'])

function handleInput(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}

defineOptions({
  inheritAttrs: false,
})
</script>
